import ResourcePage from "@/components/common/ResourcePage";
import { Badge } from "@/components/common/DataTable";

export function PartnersPage() {
  return (
    <ResourcePage
      title="Partners" subtitle="Implementation, referral & OEM partners"
      base="/v1/partners" perm="PARTNER"
      columns={[
        { key: "partnerCode", header: "Code", render: (r) => <span className="font-mono text-xs font-semibold">{r.partnerCode}</span> },
        { key: "partnerName", header: "Name" },
        { key: "type", header: "Type", render: (r) => <Badge color="blue">{r.type}</Badge> },
        { key: "commissionPct", header: "Commission %", render: (r) => `${r.commissionPct ?? 0}%` },
        { key: "status", header: "Status" },
      ]}
      fields={[
        { name: "partnerCode", label: "Partner Code", immutable: true },
        { name: "partnerName", label: "Partner Name" },
        { name: "type", label: "Type", type: "select", options: ["Implementation", "Referral", "OEM", "Distributor"] },
        { name: "commissionPct", label: "Commission %", type: "number" },
        { name: "revenueSharePct", label: "Revenue Share %", type: "number" },
        { name: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
      ]}
    />
  );
}

export function ResellersPage() {
  return (
    <ResourcePage
      title="Resellers" subtitle="Resellers & distributors"
      base="/v1/resellers" perm="RESELLER"
      columns={[
        { key: "resellerCode", header: "Code", render: (r) => <span className="font-mono text-xs font-semibold">{r.resellerCode}</span> },
        { key: "resellerName", header: "Name" },
        { key: "type", header: "Type", render: (r) => <Badge color="blue">{r.type}</Badge> },
        { key: "status", header: "Status" },
      ]}
      fields={[
        { name: "resellerCode", label: "Reseller Code", immutable: true },
        { name: "resellerName", label: "Reseller Name" },
        { name: "type", label: "Type", type: "select", options: ["Reseller", "Distributor"] },
        { name: "commissionPct", label: "Commission %", type: "number" },
        { name: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
      ]}
    />
  );
}
